module.exports = __webpack_public_path__ + "media/MRI21C.1002ec3f.mp3";